export default __webpack_public_path__ + "static/media/addresse-postale.6f0be7f0.svg";